<template>
  <div class="basciMessage">
    <a-form-model
      ref="ruleForm"
      :model="form"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <a-form-model-item label="作业标题：" prop="workName">
        <a-input v-model="form.workName" placeholder="请输入作业标题，不超过100字" />
      </a-form-model-item>
      <a-form-model-item label="作业要求：" prop="workRequire">
        <editor
            @getEditorHtml="getEditorHtml"
            :editorHtml="formattDes"
            ref="editor"
        ></editor>
        <!-- <a-input v-model="form.workRequire" type="textarea" rows="5" placeholder="请简单描述本次作业的要求，不超过200字" /> -->
      </a-form-model-item>
      <!-- <a-form-model-item :wrapper-col="{ span: 4, offset: 4 }">
          <a-button @click="onSubmit" type="primary">保存</a-button>
      </a-form-model-item> -->
    </a-form-model>
  </div>
</template>

<script>
// import { mapGetters } from 'vuex';
import Editor from './../../../../components/Editor.vue';

export default {
  components: {
    Editor
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      taskCoverNum: 5,
      form: {
        workName: '',
        workRequire: ''
      },
      rules: {
        workName: [
          { required: true, message: '请输入作业标题', trigger: 'blur' },
          { max: 100, message: '最多输入100个字符', trigger: 'blur' }
        ],
        workRequire: [
          { required: true, message: '请简单描述本次作业的要求', trigger: 'blur' },
          // { max: 200, message: '最多输入200个字符', trigger: 'blur' }
        ]
      },
      editorRes : '',
      formattDes : '',
    }
  },
  // computed: {
  //   ...mapGetters([
  //     'getCourseInfo'
  //   ])
  // },
  created () {
    this.getOneAttInfo();
  },
  methods: {
    getOneAttInfo(){
      let url = this.apis.coursework.getOneAttInfoById + this.appUtils.getCourseInfo().attinfoId;
      this.http.get(url)
      .then((res)=>{
        this.form.workName = res.data.attTitle;
        this.form.workRequire = res.data.attDes;
        this.formattDes = res.data.attDes;
        this.$refs.editor.setEditor(res.data.attDes);
      }).catch((err)=> {
        console.log(err);
      });
    },
    getEditorHtml(res){
      console.log(res);
      if (res == '<p><br></p>'){
          this.$message.error('内容不能为空');
          return
      }
      this.formattDes = res;
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.sbmBasicSetup();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    onSubmit() {
      this.$refs.editor.getEditor();
      
    },
    sbmBasicSetup(){
      let url = this.apis.coursework.putCoursework + this.appUtils.getCourseInfo().attinfoId;
      this.http.put(url,{
        'attDes': this.formattDes,
        'attTitle': this.form.workName
      })
      .then((res)=>{
        if (res.status == 0){
          // this.$message.success('保存成功');
        } else {
          this.$message.error(res.message);
        }
      }).catch((err)=> {
        console.log(err);
      });
    }
  }
}
</script>

<style lang="less">
.basciMessage{
  text-align: start;
  padding: 20px 50px 0px;
  .upload{
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    width: 550px;
    padding-top: 12px;
    .uploadWrap{
      text-align: left;
      display: inline-block;
      margin-left: 20px;
    }
  }
}
</style>